
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class RisorseDialog extends Serenity.EntityDialog<RisorseRow, any> {
        protected getFormKey() { return RisorseForm.formKey; }
        protected getIdProperty() { return RisorseRow.idProperty; }
        protected getLocalTextPrefix() { return RisorseRow.localTextPrefix; }
        protected getNameProperty() { return RisorseRow.nameProperty; }
        protected getService() { return RisorseService.baseUrl; }
        protected getDeletePermission() { return RisorseRow.deletePermission; }
        protected getInsertPermission() { return RisorseRow.insertPermission; }
        protected getUpdatePermission() { return RisorseRow.updatePermission; }

        protected form = new RisorseForm(this.idPrefix);

        constructor() {
            super();

            //
            this.form.IsUrlAssetBundleEsterno.changeSelect2(e => {
                q.readOnlyEditor(this.form.UrlAssetBundle, !this.form.IsUrlAssetBundleEsterno.value);
                q.readOnlyEditor(this.form.PathFileAssetBundle, this.form.IsUrlAssetBundleEsterno.value);
            });

            //
            this.form.IsUrlCoverAssetBundleEsterno.changeSelect2(e => {
                q.readOnlyEditor(this.form.UrlCoverAssetBundle, !this.form.IsUrlCoverAssetBundleEsterno.value);
                q.readOnlyEditor(this.form.PathFileCoverAssetBundle, this.form.IsUrlCoverAssetBundleEsterno.value);
            });

            //
            this.form.IsUrlManifestAssetBundleEsterno.changeSelect2(e => {
                q.readOnlyEditor(this.form.UrlManifestAssetBundle, !this.form.IsUrlManifestAssetBundleEsterno.value);
                q.readOnlyEditor(this.form.PathFileManifestAssetBundle, this.form.IsUrlManifestAssetBundleEsterno.value);
            });
        }

        protected getToolbarButtons() {
            let buttons = super.getToolbarButtons();

            var buttonApply = Q.first(buttons, x => x.cssClass == "apply-changes-button");
            buttonApply.title = "Salva e continua";

            return buttons;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            // Questa gestisce l'editor.          
            this.form.AssetEsperienzeList.ambito = AssetEsperienzeRisorse2Editor.AmbitoEnum.VisualizzaAssetEsperienze;
            this.form.AssetEsperienzeList.idRisorsa = this.form.IdRisorsa.value;

            this.form.ProdottiList.ambito = ProdottiRisorse2Editor.AmbitoEnum.VisualizzaProdotti;
            this.form.ProdottiList.idRisorsa = this.form.IdRisorsa.value;
        }

        loadEntity(entity: ChecklistRow) {
            super.loadEntity(entity);
        }
    }
}